<div class="data-empty {{custClass}}">

  <ng-lottie *ngIf="!img" [options]="options"></ng-lottie>

  <img [src]="img" *ngIf="img" alt="">

  <h3 *ngIf="title">{{title}}</h3>
  <p *ngIf="desc">{{desc}}</p>
  <h2 *ngIf="subTitle">{{subTitle}}</h2>
</div>
